<template>
  <div class="add_test__step-2 vs-con-loading__container">
    <!-- select lab test -->
    <div class="w-1/2 mx-auto">
      <label for="">Select Lab</label>
      <select-2 ref="lab" autocomplete :value="step2.lab" @input="(e) => (step2.lab = e.value)" name="Lab" placeholder="Please Select Lab" :options="labsOptions" v-validate="'required'" />
      <span class="text-danger text-sm mx-auto text-center" v-show="errors.has('Lab')">{{ errors.first('Lab') }}</span>
      <br />
      <span class="text-primary text-sm mx-auto text-center" v-show="!!lab"><strong>Note:- </strong> {{ lab && lab.note }} </span>
    </div>

    <ProductListTable :step="step" />

    <div class="lab_test__note mt-5 text-danger text-sm font-bold">
      <p>Please contact {{ (lab && lab.name) || 'xxx' }} at {{ (lab && lab.mobile) || '(xxx) xxx-xxxxx' }} to schedule a drop off</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ProductListTable from '@/views/lab-tests/components/ProductListTable.vue'
import Select2 from '@/components/custom/form-elements/Select2.vue'

export default {
  name: 'AddTestStep2',
  components: {
    ProductListTable,
    Select2
  },
  props: {
    fetchLabList: Boolean,
    step2: {
      lab: Number
    }
  },

  data() {
    return {
      step: 2
    }
  },

  computed: {
    ...mapState('lab', ['labs', 'loading']),
    lab() {
      return this.labs.find((x) => x.id === this.step2.lab)
    },

    labsOptions() {
      return this.labs.reduce((acc, item) => {
        item.label = item.name
        item.value = item.id

        acc.push(item)

        return acc
      }, [])
    }
  },
  // methods
  methods: {
    ...mapActions('lab', { fetchAllLabs: 'getLabList', fetchLabProducts: 'getLabProducts' }),

    // get all lab list
    async getAllLabs() {
      try {
        const payload = {
          limit: 0,
          page: 1,
          action: true
        }

        await this.fetchAllLabs(payload)
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    async get_lab_products(labId) {
      try {
        const data = {
          limit: 0,
          page: 1,
          status: true
        }

        this.$emit('update:step2', this.step2)

        await this.fetchLabProducts({ labId, data })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },
  watch: {
    async fetchLabList() {
      await this.getAllLabs()
    },

    'step2.lab': {
      immediate: true,
      handler(newVal) {
        this.get_lab_products(newVal)
      }
    },

    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '.add_test__step-2',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('.add_test__step-2 > .con-vs-loading')
      }
    }
  }
}
</script>

<style></style>
